(() => {
  const stylesheet = document.querySelector('link[data-cp-full-css]');
  if (stylesheet) {
    const media = stylesheet.dataset.cpMedia || 'all';
    let started = false;
    let timeout;
    const start = () => {
      if (started) return;
      started = true;
      clearTimeout(timeout);
      // Avoid loading a mobile-only stylesheet on a desktop viewport.
      if (media !== 'all' && !window.matchMedia(media).matches) {
        started = false;
        return;
      }
      stylesheet.href = stylesheet.dataset.cpHref;
      stylesheet.media = media;
      delete stylesheet.dataset.cpHref;
      for (const event of ['scroll', 'pointerdown', 'touchstart', 'keydown', 'focusin']) {
        window.removeEventListener(event, start);
      }
    };
    for (const event of ['scroll', 'pointerdown', 'touchstart', 'keydown', 'focusin']) {
      window.addEventListener(event, start, { passive: true, once: true });
    }
    timeout = setTimeout(start, 6000);
    if (media !== 'all') {
      const mq = window.matchMedia(media);
      if (mq.addEventListener) mq.addEventListener('change', () => { if (mq.matches) start(); });
      else if (mq.addListener) mq.addListener(() => { if (mq.matches) start(); });
    }
    const hero = document.querySelector('main img[fetchpriority="high"]');
    const afterPaint = () => requestAnimationFrame(() => requestAnimationFrame(start));
    if (!hero) afterPaint();
    else if (hero.complete) hero.decode().catch(() => {}).finally(afterPaint);
    else {
      hero.addEventListener('load', afterPaint, { once: true });
      hero.addEventListener('error', start, { once: true });
    }
  }
  if (customElements.get('cp-deferred-media')) return;
  const waiting = new Map();
  const ready = new WeakSet();
  const activate = (media) => {
    if (media.dataset.cpSrcset) {
      media.srcset = media.dataset.cpSrcset;
      delete media.dataset.cpSrcset;
    }
    if (media.dataset.cpSrc) {
      media.src = media.dataset.cpSrc;
      delete media.dataset.cpSrc;
    }
    if (media.dataset.cpPoster) {
      media.poster = media.dataset.cpPoster;
      delete media.dataset.cpPoster;
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      for (const media of waiting.get(entry.target) || []) activate(media);
      ready.add(entry.target);
      waiting.delete(entry.target);
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '300px 150px', threshold: 0 }) : null;
  customElements.define('cp-deferred-media', class extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('img,video');
      if (!this.media) return;
      this.target = this.closest('testimonials-slider,.complete-look,[class*="ai-featured-collection__grid--slider"]') || this.media;
      if (!observer || ready.has(this.target)) {
        activate(this.media);
        return;
      }
      if (!waiting.has(this.target)) waiting.set(this.target, new Set());
      waiting.get(this.target).add(this.media);
      observer.observe(this.target);
    }
    disconnectedCallback() {
      const media = waiting.get(this.target);
      if (!media) return;
      media.delete(this.media);
      if (!media.size) {
        waiting.delete(this.target);
        if (observer) observer.unobserve(this.target);
      }
    }
  });
})();
